
import userManager from './userManager'
import entsManager from './entsManager'
import knowledge from './knowledge'
import message from './message'
import changePwd from './changePwd'
const modules = {
  path: '/',
  component: resolve => require(['../../../pages/modules'], resolve),
  redirect: '/userManager',
  children: [
    userManager,
    entsManager,
    knowledge,
    message,
    changePwd
  ]
}

export default modules
